import React from "react";
import style from "./CustomInput.module.scss";

const CustomInput = ({ touched, errors, disableLabel, ...props }, ref) => {
  return (
    <div className="form-group w-100">
      <input
        ref={ref}
        {...props}
        className={props.className + " " + style.input}
      />
      {touched?.[props.id] && errors?.[props.id] && (
        <p className="error-message">{errors?.[props.id]}</p>
      )}
    </div>
  );
};

export default React.forwardRef(CustomInput);
